<template>
    <section class="border-b border-white">
        <dealer-list-mobile  :dealers="dealers"
                             :loading="loading"
                             :searchLocation.sync="address"
                             :searchCategory.sync="category"
                             :availableCategories="availableCategories"
                             :pageInfo="pageInfo"
                             :loading-more="loadingMore"
                             @loadMore="loadMore"
        />
        <dealer-list-desktop :dealers="dealers"
                             :loading="loading"
                             :searchLocation.sync="address"
                             :searchCategory.sync="category"
                             :availableCategories="availableCategories"
                             :pageInfo="pageInfo"
                             :loading-more="loadingMore"
                             @loadMore="loadMore"
        />
    </section>
</template>

<script>
    import api from '../../js/api/dealers'
    import debounce from 'lodash/debounce';

    import DealerListDesktop from "./DealerListDesktop.vue";
    import DealerListMobile from "./DealerListMobile.vue";

    export default {
        name: 'DealerLocator',
        components: {
            DealerListDesktop,
            DealerListMobile
        },
        data: () => {
            return {
                loading: null,
                loadingMore: null,
                address: '',
                dealers: [],
                availableCategories: [],
                pageInfo: null,
                position: null,
                category: null
            }
        },
        watch: {
            address: function (val) {
                this.position = null;
                this.handleQueryChange();
            },
            category: function (val) {
              if (!!this.address || !!this.position) {
                this.handleQueryChange();
              }
            },
        },
        mounted() {
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(position => {
                    this.position = position.coords;
                    this.handleQueryChange();
                })
            }

            api.getDealerCategories().then((resp) => {
              this.availableCategories = [{title:'All Dealers', slug:'all-dealers'}].concat(resp.data.data).concat([{title:'Backerboard Only', slug:'backerboard-only'}]);
              this.category = 'All Dealers';
            });
        },
        methods: {
            loadMore: function() {
                this.loadingMore = true;
                api.getDealers(this.address,this.pageInfo.current_page + 1, 'mi', this.category === 'All Dealers' ? null : this.category, this.position).then((resp) => {
                    this.dealers = this.dealers.concat(
                        resp.data.data.map(dealer => {
                          if (dealer.categories && dealer.categories.data) {
                            dealer.categories = dealer.categories.data;
                          }
                          return dealer;
                        })
                    );
                    this.pageInfo = resp.data.meta.pagination;
                }).finally(() => {
                    this.loadingMore = false
                });
            },
            handleQueryChange: debounce(function() {
                this.loading = true;
                this.dealers = [];
                api.getDealers(this.address, 1, 'mi', this.category === 'All Dealers' ? null : this.category, this.position).then((resp) => {
                    this.dealers = resp.data.data.map(dealer => {
                      if (dealer.categories && dealer.categories.data) {
                        dealer.categories = dealer.categories.data;
                      }
                      return dealer;
                    });
                    this.pageInfo = resp.data.meta.pagination;
                }).finally(() => {
                    this.loading = false
                });
            }, 700)
        }
    }
</script>